






















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import teamInfo from "@/components/teamInfo.vue";
import teamChange from "@/components/teamChange.vue";
import consts from "../../consts";
import { Team, User, UserStat } from "../../types";
import axios from "axios";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamInfo,
    teamChange,
  },
})
export default class Users extends Vue {
  @Getter private JWT?: string;
  @Prop() private teamID!: string;
  @Getter private UID?: string;
  @Getter private currentTeamID?: string;
  @Getter private currentTeam?: Team;
  @Getter private currentTeamUsers?: User[];
  @Getter private userStats?: UserStat[];
  @Action private fetchCurrentTeamStats!: () => any;
  @Action private fetchTeamUsers!: (teamID: number) => any;
  @Getter private userByID!: (uid: string) => User;
  @Prop() private changeTeam!: (teamID: any) => any;

  private currUser!: User;

  private activityCurrentPage: number = 1;
  private usersFilter: string = "";
  private deleteModalShow: boolean = false;
  private deleteModalError: boolean = false;
  private addFirstName: string = "";
  private addLastName: string = "";
  private addEmail: string = "";
  private selected: number[] = [];
  private isInviting: boolean = false;
  private invitingUserID: string = "";
  private statusFilter: string = "all";
  private defaultToastProps = {
    autoHideDelay: 10000,
    solid: true,
    toaster: "b-toaster-bottom-right",
    appendToast: true,
  };

  private created() {
    if (this.UID) {
      this.currUser = this.userByID(this.UID);
    }
  }

  private usersStartingWith(letter: string) {
    if (this.filteredUserStats) {
      return this.filteredUserStats.filter((user) => {
        return user.Name.toLowerCase().charAt(0) === letter;
      });
    }
  }

  private cancelDelete() {
    this.selected = [];
  }

  private handleDelete() {
    let len = this.selected.length;
    let count = 0;

    // check for self delete
    if (this.currUser && this.isSelected(this.currUser.ID)) {
      this.deleteModalError = true;
      this.cancelDelete();
      return;
    }

    this.deleteModalShow = false;
    for (let i = 0; i < len; i++) {
      let id = this.selected[i];
      if (id) {
        axios({
          method: "DELETE",
          url: consts.serverURL + "team/" + this.teamID + "/user/" + id,
          headers: { Authentication: this.JWT },
        })
          .then((resp) => {
            count++;
            // Last delete so refresh
            if (count === len) {
              this.refreshTeamUsersData();
            }
            console.log("DELETE USER", resp.data);
          })
          .catch((reason) => {
            count++;
            // Last delete so refresh
            if (count === len) {
              this.refreshTeamUsersData();
            }
            console.log(reason, reason.response);
          });
      }
    }

    this.selected = [];
  }

  private refreshTeamUsersData() {
    if (this.currentTeam) {
      this.fetchTeamUsers(this.currentTeam.ID);
      this.fetchCurrentTeamStats();
    }
  }

  private handleResendInvite(userID: any) {
    const self = this;
    self.isInviting = true;
    self.invitingUserID = userID;

    axios({
      method: "POST",
      url:
        consts.serverURL +
        "team/" +
        this.teamID +
        "/user/" +
        userID +
        "/resend-invite",
      headers: { Authentication: this.JWT },
    })
      .then((resp) => {
        self.isInviting = false;
        self.$bvToast.toast(resp.data.Description, {
          title: "Resend Invite",
          variant: "success",
          ...this.defaultToastProps,
        });
      })
      .catch((reason) => {
        self.isInviting = false;
        self.$bvToast.toast(reason.response.data.Error, {
          title: "Resend Invite",
          variant: "danger",
          ...this.defaultToastProps,
        });
      });
  }

  private isSelected(id: number) {
    return this.selected.indexOf(id) >= 0;
  }

  private initials(name: string) {
    if (!name) {
      return "?";
    }
    return name
      .split(" ")
      .filter((part) => part.length > 0)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  }

  private roleLabel(role: string) {
    if (!role) {
      return "User";
    }
    return role
      .split("_")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  private filterStatus(user: User) {
    if (this.statusFilter === "invited") {
      return user.AcceptedOn === null;
    } else if (this.statusFilter === "accepted") {
      return user.AcceptedOn !== null;
    }
    return true;
  }

  get filteredUserStats() {
    if (this.currentTeamUsers) {
      return this.currentTeamUsers.filter((user) => {
        if (user.Name) {
          const userName = user.Name.toLowerCase();
          return (
            userName.indexOf(this.usersFilter.toLowerCase()) >= 0 &&
            this.filterStatus(user)
          );
        }
        return false;
      });
    }
  }

  get lettersUsersStartWith() {
    const letters = [];
    for (let i = 0; i < 27; i++) {
      const letter = String.fromCharCode(96 + i);
      let usersStartingWith = this.usersStartingWith(letter);
      if (usersStartingWith && usersStartingWith.length) {
        letters.push(letter);
      }
    }

    return letters;
  }
}
